<template>
  <router-link v-if='kirby.site' to='/'>
    <ScrollListener v-slot='{ scroll }'>
      <SideBarGraphic :scroll='scroll'/>
    </ScrollListener>
    <ScrollListener v-slot='{ scroll }'>
      <CurveText id="CurveText" :scroll='scroll'/>
    </ScrollListener>
  </router-link>
</template>

<script>
import mixins from '.././mixins.js';
export default { mixins: [mixins] }
</script>

<style scoped>

  a {
    position: fixed;
    top: 0;
    left: 0;
    width: 6.25rem;
    padding: 0 0.25rem;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 4;
  }

  #CurveText {
    position: absolute;
    top: var(--curvetexttop);
    left: calc(6rem + 0.5rem);
  }

</style>
